<template>
  <KisweSelect
    class="language-selector"
    :model-value="currentLocale"
    :options="localeOptions"
    :popperClass="props.popperClass"
    @update:model-value="setCurrentLocale"
    data-qa="select-language-selector"
  />
</template>

<script lang="ts" setup>
import './LanguageSelector.scss'
import { computed } from 'vue'
import { KisweSelect, KisweSelectOption } from 'kiswe-ui'
import { localeInfo, SupportedLocale } from '@/plugins/translations/types'
import { useLocale } from '@/modules/translation/compositions'

const props = withDefaults(defineProps<{
  popperClass?: string,
}>(), {
  popperClass: ''
})

const { currentLocale, setLocale } = useLocale()

const localeOptions = computed<KisweSelectOption[]>(() => {
  return Object.values(SupportedLocale)
    .map((locale) => ({ label: localeInfo[locale].title, value: locale }))
})

const setCurrentLocale = async (newVal: unknown) => {
  const isSupportedLocale = typeof newVal === 'string'
    && Object.values(SupportedLocale).includes(newVal as SupportedLocale)
  if (isSupportedLocale) {
    await setLocale(newVal as SupportedLocale)
  } else {
    console.error(`Cannot set locale "${ newVal }". Not part of the supported locales.`)
  }
}
</script>
